if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');
        this.elements = {
          inputs: this.querySelectorAll('input[name="locale_code"], input[name="country_code"]'),
          buttons: this.querySelectorAll('button.localization-form__select'),
          panels: this.querySelectorAll('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
          saveButton: this.querySelector('button.localization-form__save'),
        };
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.closeSelector.bind(this));
        
        // 为每个选择按钮添加事件监听器
        this.elements.buttons.forEach((button) => {
          button.addEventListener('click', this.openSelector.bind(this));
        });

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }
        if (this.elements.saveButton) {
          this.elements.saveButton.addEventListener('click', this.onSaveClick.bind(this));
        }

        this.pendingExternalUrl = '';
        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.buttons.forEach((button) => {
          button.setAttribute('aria-expanded', 'false');
        });
        this.elements.panels.forEach((panel) => {
          panel.setAttribute('hidden', true);
        });
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }
        document.body.classList.remove('overflow-hidden-mobile');
        document.querySelector('.menu-drawer').classList.remove('country-selector-open');
        this.header.preventHide = false;
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            const expandedButton = Array.from(this.elements.buttons).find(btn => btn.getAttribute('aria-expanded') === 'true');
            if (!expandedButton) return;
            this.hidePanel();
            event.stopPropagation();
            expandedButton.focus();
            break;
          case 'SPACE':
            const targetButton = event.target.closest('button.localization-form__select');
            if (!targetButton) return;
            if (targetButton.getAttribute('aria-expanded') === 'true') return;
            this.openSelector({ currentTarget: targetButton });
            break;
        }
      }

      onItemClick(event) {
        event.preventDefault();
        const value = event.currentTarget.dataset.value;
        const itemText = event.currentTarget.textContent.trim();
        const externalUrl = event.currentTarget.dataset.externalUrl;
        
        const isCountrySelector = event.currentTarget.closest('.country-selector') || 
                                 event.currentTarget.closest('[id*="country"]');
        if (isCountrySelector) {
          this.pendingExternalUrl = externalUrl || '';
        }
        const inputName = isCountrySelector ? 'country_code' : 'locale_code';
        const input = this.querySelector(`input[name="${inputName}"]`);
        
        if (input) {
          input.value = value;
        }
        
        const button = event.currentTarget.closest('.disclosure').querySelector('button.localization-form__select');
        if (button) {
          const buttonSpan = button.querySelector('span');
          if (buttonSpan) {
            if (isCountrySelector) {
              const countryImg = buttonSpan.querySelector('img');
              if (countryImg) {
                countryImg.src = `https://cdn.shopify.com/static/images/flags/${value.toLowerCase()}.svg`;
                countryImg.alt = value.toLowerCase();
              }
              const countryName = itemText.replace(/^\s*/, ''); 
              buttonSpan.innerHTML = `<img loading="lazy" src="https://cdn.shopify.com/static/images/flags/${value.toLowerCase()}.svg" width="22" height="14" alt="${value.toLowerCase()}"> ${countryName}`;
              
            } else {
              buttonSpan.textContent = itemText;
            }
          }
        }
        
        this.hidePanel();
      }

      onSaveClick(event) {
        event.preventDefault();
        if (this.pendingExternalUrl) {
          window.location.assign(this.pendingExternalUrl);
          return;
        }
        const form = this.querySelector('form');
        if (form) {
          form.submit();
        }
      }

      openSelector(event) {
        const button = event.currentTarget;
        const panel = button.nextElementSibling;
        
        this.elements.panels.forEach((p) => {
          if (p !== panel) {
            p.setAttribute('hidden', true);
          }
        });
        this.elements.buttons.forEach((b) => {
          if (b !== button) {
            b.setAttribute('aria-expanded', 'false');
          }
        });
        
        button.focus();
        panel.toggleAttribute('hidden');
        button.setAttribute(
          'aria-expanded',
          (button.getAttribute('aria-expanded') === 'false').toString()
        );
        if (!document.body.classList.contains('overflow-hidden-tablet')) {
          document.body.classList.add('overflow-hidden-mobile');
        }
        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }
        if (this.hasAttribute('data-prevent-hide')) {
          this.header.preventHide = true;
        }
        document.querySelector('.menu-drawer').classList.add('country-selector-open');
      }

      closeSelector(event) {
        if (
          event.target.classList.contains('country-selector__overlay') ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          this.hidePanel();
        }
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }

      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a');
        let visibleCountries = allCountries.length;

        this.elements.resetButton.classList.toggle('hidden', !searchValue);

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', searchValue);
        }

        allCountries.forEach((item) => {
          const countryElement = item.querySelector('.country');
          if (!countryElement) return; // 跳过没有 .country 类的项目（如语言选择器）
          
          const countryName = this.normalizeString(countryElement.textContent);
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove('hidden');
            visibleCountries++;
          } else {
            item.parentElement.classList.add('hidden');
            visibleCountries--;
          }
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCountries
          );
        }

        this.querySelector('.country-selector').scrollTop = 0;
        this.querySelector('.country-selector__list').scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }
    }
  );
}